"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var AsyncStateManager = /** @class */ (function () {
    function AsyncStateManager() {
        this._readinessProbes = {};
        this._subscriptions = {};
    }
    AsyncStateManager.prototype.addSubscription = function (key, subscription, alwaysReady) {
        if (alwaysReady === void 0) { alwaysReady = false; }
        if (!this._readinessProbes.hasOwnProperty(key)) {
            this._readinessProbes = lodash_1.set(this._readinessProbes, key, alwaysReady);
        }
        this._subscriptions = lodash_1.set(this._subscriptions, key, subscription);
    };
    AsyncStateManager.prototype.setReady = function (key) {
        this._readinessProbes = lodash_1.set(this._readinessProbes, key, true);
    };
    AsyncStateManager.prototype.setUnReady = function (key) {
        this._readinessProbes = lodash_1.set(this._readinessProbes, key, false);
    };
    AsyncStateManager.prototype.isReady = function () {
        return lodash_1.values(this._readinessProbes).reduce(function (reduction, value) { return reduction && value; });
    };
    AsyncStateManager.prototype.destroy = function () {
        lodash_1.values(this._subscriptions).forEach(function (subscription) { return subscription.unsubscribe(); });
        this._readinessProbes = undefined;
        this._subscriptions = undefined;
    };
    return AsyncStateManager;
}());
exports.AsyncStateManager = AsyncStateManager;
//# sourceMappingURL=async-state-manager.js.map